import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { ProductModel } from '../model/product.model';

@Injectable()
export class ProductService {

    path = '/products';

    constructor(private baseService: BaseService) { }

    getPaginated(init: number, end: number, q?: string, measure_table_id?: number) {
        const params: any = { init, end };
        if (q) params.q = q;
        if (measure_table_id) params.measure_table_id = measure_table_id;
        return this.baseService.get(this.path, '', params);
    }

    getById(id: number) {
        return this.baseService.get(this.path, '/' + id, {});
    }

    post(model: ProductModel) {
        return this.baseService.post(this.path, '/', model);
    }

    put(model: any) {
        return this.baseService.put(this.path, '/' + model.id, model);
    }

    save(model: any) {
        return model.id ? this.put(model) : this.post(model);
    }

    delete(id: number) {
        return this.baseService.delete(this.path, '/' + id);
    }

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/product.service.ts